import { Navigate } from "react-router-dom";
import { useState } from "react";
import EmpHeaderSection from "../app/pannels/employer/common/emp-header";
import AdminSidebarSection from "../app/pannels/admin/common/admin-sidebar";
import AdminRoutes from "../routing/admin-routes";
import YesNoPopup from "../app/common/popups/popup-yes-no";
import { popupType } from "../globals/constants";
import { publicUser } from "../globals/route-names";
import { useAuth } from "../context/AuthContext";

function AdminLayout() {
    const [sidebarActive, setSidebarActive] = useState(true);
    const { user, loading } = useAuth();

    if (loading) return <div className="p-a30 text-center">Loading admin account...</div>;
    if (!user) return <Navigate to={publicUser.pages.LOGIN} replace />;
    if (user.role !== "admin") return <Navigate to={publicUser.pages.LOGIN} replace />;

    return (
        <div className="page-wraper">
            <EmpHeaderSection onClick={() => setSidebarActive(!sidebarActive)} sidebarActive={sidebarActive} />
            <AdminSidebarSection sidebarActive={sidebarActive} />
            <div id="content" className={sidebarActive ? "" : "active"}>
                <div className="content-admin-main">
                    <AdminRoutes />
                </div>
            </div>
            <YesNoPopup id="logout-dash-profile" type={popupType.LOGOUT} msg={"Do you want to Logout your profile?"} />
        </div>
    );
}

export default AdminLayout;
